import React, { Component } from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import { Accordion, Card, Button, FormControl, useAccordionToggle, Spinner } from "react-bootstrap";
import { OperationalBudget } from '../../../../Common/Services/OperationalBudget';
import { Utils } from "../../../../Common/Utilis";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

//wrapper function to create a custom toggle for Accordian
function CustomToggle({ children, eventKey, onToggle, isOpen }) {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
        onToggle(eventKey);
    });
    return (
        <div className={`accordian-arrow ${isOpen ? 'rotate' : ''}`} onClick={decoratedOnClick}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.52855 11.2499L12.9711 7.80736C13.2636 7.51486 13.2636 7.04236 12.9711 6.74986C12.6786 6.45736 12.2061 6.45736 11.9136 6.74986L8.99605 9.65986L6.08605 6.74986C5.79355 6.45736 5.32105 6.45736 5.02855 6.74986C4.73605 7.04236 4.73605 7.51486 5.02855 7.80736L8.47105 11.2499C8.75605 11.5424 9.23605 11.5424 9.52855 11.2499Z" fill="#1D1E20" />
            </svg>
        </div>
    )
}

export class RoomRevenue extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            openEventKey: ['0'],
            apiData: [],
            tablesData: [],
            tablesDataCopy: [],
            distinctTablesDetails: [],
            isDataLoaded: false,
            roomCountArr: [],
            showLoader: false,
            selectedHid: props?.hidValue === undefined || props?.hidValue === null || props?.hidValue === "" ? 1430 : props?.hidValue,
            selectedYear: props?.selectedYear === undefined || props?.selectedYear === null || props?.selectedYear === "" ? 2024 : props?.selectedYear,
            isModified: false,
        };
    }

    componentDidMount() {
        // this.getRoomRevenueBudget();
        this.getHotelRoomCount();
    }

    getRoomRevenueBudget = () => {
        let request: any = {};
        request.Hid = this.state.selectedHid;
        request.year = this.state.selectedYear;
        request.Type = "ADR";
        request.BudgetId = "Budget";
        this.setState({ showLoader: true, });
        OperationalBudget.GetRoomRevenueBudget(request)
            .then(async (result: any | null) => {
                if (result !== null && result.length > 0) {
                    let distinctTablesDetails: any = [];
                    distinctTablesDetails = result.map(data => data.budgetType).filter((val, index, self) => self.indexOf(val) === index).map(val => ({ budgetType: val }));
                    for (let i = 0; i < distinctTablesDetails.length; i++) {
                        let distinctNames = result.filter(data => data.budgetType === distinctTablesDetails[i].budgetType).map(data => data.segmentName).filter((val, index, self) => self.indexOf(val) === index);
                        let subType = result.filter(data => data.budgetType === distinctTablesDetails[i].budgetType).map(data => data.subType).filter((val, index, self) => self.indexOf(val) === index);
                        let subType1 = result.filter(data => data.budgetType === distinctTablesDetails[i].budgetType).map(data => data.subType1).filter((val, index, self) => self.indexOf(val) === index);
                        distinctTablesDetails[i].distinctNames = distinctNames;
                        distinctTablesDetails[i].subType = subType;
                        distinctTablesDetails[i].subType1 = subType1;
                        distinctTablesDetails[i].firstHeader = distinctTablesDetails[i].budgetType === "Total Occupancy" ? "" : distinctTablesDetails[i].budgetType === "Summary" ? "COA Name" : "Segment";
                    }
                    let tablesData: any = [];
                    for (let i = 0; i < distinctTablesDetails.length; i++) {
                        if (i === 2) {
                            continue;
                        }
                        for (let j = 0; j < distinctTablesDetails[i].distinctNames.length; j++) {
                            if (i === 1 && distinctTablesDetails[i].distinctNames[j].toLowerCase() !== "ztotal") {
                                let rowData: any = {};
                                rowData.isSubHeader = true;
                                rowData.id = "table" + i + "-" + j + "-subheader";
                                rowData.budgetType = distinctTablesDetails[i].budgetType;
                                rowData.name = distinctTablesDetails[i].distinctNames[j];
                                rowData.displayName = distinctTablesDetails[i].distinctNames[j].toLowerCase() === "ztotal" ? "Avg/Total" : distinctTablesDetails[i].distinctNames[j];

                                for (let k = 0; k < distinctTablesDetails[i].subType1.length; k++) {
                                    rowData[distinctTablesDetails[i].subType1[k]] = "";
                                    for (let l = 1; l < 13; l++) {
                                        rowData[distinctTablesDetails[i].subType1[k] + "-per" + l] = "";
                                    }
                                    rowData["total-" + distinctTablesDetails[i].subType1[k]] = "";
                                }
                                tablesData.push(rowData);
                            }

                            let rowData: any = {};
                            rowData.isSubHeader = false;
                            rowData.id = "table" + i + "-" + j;
                            rowData.budgetType = distinctTablesDetails[i].budgetType;
                            rowData.name = distinctTablesDetails[i].distinctNames[j];
                            if (i === 1) {
                                rowData.displayName = distinctTablesDetails[i].distinctNames[j].toLowerCase() === "ztotal" ? "Avg/Total" : "Occupancy";
                            } else {
                                rowData.displayName = distinctTablesDetails[i].distinctNames[j].toLowerCase() === "ztotal" ? "Avg/Total" : distinctTablesDetails[i].distinctNames[j];
                            }

                            for (let k = 0; k < distinctTablesDetails[i].subType1.length; k++) {
                                rowData[distinctTablesDetails[i].subType1[k]] = distinctTablesDetails[i].subType[k];
                                for (let l = 1; l < 13; l++) {
                                    rowData[distinctTablesDetails[i].subType1[k] + "-per" + l] = result.filter((data) => data.budgetType === distinctTablesDetails[i].budgetType && data.segmentName === distinctTablesDetails[i].distinctNames[j] && data.subType1 === distinctTablesDetails[i].subType1[k])[0]?.["per" + l] || "0.00";
                                }
                                rowData["total-" + distinctTablesDetails[i].subType1[k]] = result.filter((data) => data.budgetType === distinctTablesDetails[i].budgetType && data.segmentName === distinctTablesDetails[i].distinctNames[j] && data.subType1 === distinctTablesDetails[i].subType1[k])[0]?.total || "0.00";
                            }
                            tablesData.push(rowData);

                            if (i === 1) {
                                let rowData: any = {};
                                rowData.isSubHeader = false;
                                rowData.id = "table" + (i + 1) + "-" + j;
                                rowData.budgetType = distinctTablesDetails[i + 1].budgetType;
                                rowData.name = distinctTablesDetails[i + 1].distinctNames[j];
                                rowData.displayName = distinctTablesDetails[i + 1].distinctNames[j].toLowerCase() === "ztotal" ? "Avg/Total" : "ADR";
                                for (let k = 0; k < distinctTablesDetails[i + 1].subType1.length; k++) {
                                    rowData[distinctTablesDetails[i + 1].subType1[k]] = distinctTablesDetails[i + 1].subType[k];;
                                    for (let l = 1; l < 13; l++) {
                                        rowData[distinctTablesDetails[i + 1].subType1[k] + "-per" + l] = result.filter((data) => data.budgetType === distinctTablesDetails[i + 1].budgetType && data.segmentName === distinctTablesDetails[i + 1].distinctNames[j] && data.subType1 === distinctTablesDetails[i + 1].subType1[k])[0]?.["per" + l] || "0.00";
                                    }
                                    rowData["total-" + distinctTablesDetails[i + 1].subType1[k]] = result.filter((data) => data.budgetType === distinctTablesDetails[i + 1].budgetType && data.segmentName === distinctTablesDetails[i + 1].distinctNames[j] && data.subType1 === distinctTablesDetails[i + 1].subType1[k])[0]?.total || "0.00";
                                }
                                tablesData.push(rowData);
                            }
                        }
                    }
                    // console.log(tablesData);
                    this.setState({ apiData: result, tablesData, tablesDataCopy: tablesData, distinctTablesDetails: distinctTablesDetails }, () => {
                        for (let i = 1; i <= 12; i++) {
                            setTimeout(() => {
                                this.calculateUpdatedData(i);
                            });
                        }
                        this.setState({ isDataLoaded: true, showLoader: false, });
                    });
                } else {
                    Utils.toastError("Failed to get Budget Details.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "OprBud_ReoomRevenue_Bud",
                    });
                    this.setState({ showLoader: false, });
                }
                resolve();
            })
            .catch((err: any) => {
                this.setState({ showLoader: false, });
                Utils.toastError(err.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "OprBud_ReoomRevenue_Bud",
                });
                reject();
            });
    }

    getHotelRoomCount = () => {
        let request: any = {};
        request.HId = this.state.selectedHid;
        request.Year = this.state.selectedYear;
        this.setState({ showLoader: true, });
        OperationalBudget.GetHotelRoomCount(request)
            .then(async (result: any | null) => {
                if (result !== null && result.length > 0) {
                    this.getRoomRevenueBudget();
                    this.setState({ roomCountArr: result, });
                } else {
                    Utils.toastError("Failed to get Hotel Room Count.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "OprBud_RC",
                    });
                    this.setState({ showLoader: false, });
                }
                resolve();
            })
            .catch((err: any) => {
                this.setState({ showLoader: false, });
                Utils.toastError(err.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "OprBud_RC_error",
                });
                reject();
            });
    }

    handleToggle = (eventKey) => {
        let openEventKey = Object.assign([], JSON.parse(JSON.stringify(this.state.openEventKey)));
        if (openEventKey.includes(eventKey)) {
            const index = openEventKey.findIndex((x) => x === eventKey);
            openEventKey.splice(index, 1);
        } else {
            openEventKey.push(eventKey);
        }
        this.setState({ openEventKey });
    };

    getColumns = (firstHeader, tableName) => {
        let distinctTablesDetails = Object.assign([], JSON.parse(JSON.stringify(this.state.distinctTablesDetails)));
        let tableIndex = distinctTablesDetails.findIndex((x) => x.budgetType === tableName);
        let tableDetails = distinctTablesDetails.filter((data) => data.budgetType === tableName)[0];
        let monthsArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",];
        let columns: any = [];

        let col1: any = {};
        col1 = {
            dataField: 'displayName',
            text: firstHeader,
            headerClasses: "width-150",
            classes: "width-150",
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div>
                        <ul>
                            <li className="ttl" key={"row-name-" + rowIndex}><EllipsisWithTooltip placement="bottom">{row.displayName}</EllipsisWithTooltip></li>
                        </ul>
                    </div>
                );
            },
        }
        columns.push(col1);
        let col2: any = {};
        col2 = {
            dataField: 'type1',
            text: "",
            headerClasses: "width-150",
            classes: "width-150",
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div>
                        {!row.isSubHeader && (
                            <ul>
                                {
                                    tableDetails.subType1.map((type, index) => {
                                        return <li key={"row-" + type + "-" + rowIndex}><EllipsisWithTooltip placement="bottom">{row[type]}</EllipsisWithTooltip></li>
                                    })
                                }
                            </ul>
                        )}
                    </div>
                );
            },
        }
        columns.push(col2);
        monthsArr.forEach((month, monIndex) => {
            let col3: any = {};
            col3 = {
                dataField: "type1-" + "per" + (monIndex + 1),
                text: month,
                headerAlign: 'right',
                align: 'right',
                formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                        <div>
                            {!row.isSubHeader && (
                                <ul>
                                    {
                                        tableDetails.subType1.map((type, typeIndex) => {
                                            if ((typeIndex === 0 && row.name.toLowerCase() !== "ztotal" && row.budgetType !== "Summary")) {
                                                return (
                                                    <li // key/id example key = input-table1-name1-type1-per1
                                                        key={"input-" + "table" + (tableIndex + 1) + "-name" + (rowIndex + 1) + "-" + type + "-per" + (monIndex + 1)}>
                                                        <FormControl
                                                            type="text"
                                                            className='height-20'
                                                            id={"input-" + "table" + (tableIndex + 1) + "-name" + (rowIndex + 1) + "-" + type + "-per" + (monIndex + 1)}
                                                            value={row[type + "-per" + (monIndex + 1)]}
                                                            onChange={(event) => this.onInputChange(event, { table: row.budgetType, tableNo: "table" + (tableIndex + 1), name: row.name, rowNo: rowIndex + 1, type: type, month: monIndex + 1 })}
                                                            onBlur={e => this.onInputBlur(e, { table: row.budgetType, tableNo: "table" + (tableIndex + 1), name: row.name, rowNo: rowIndex + 1, type: type, month: monIndex + 1 })}
                                                        />
                                                    </li>
                                                )
                                            } else {
                                                return ( //style condition is type1 && rowName is ztotal and table is "Occupancy by Segmentation" && value !== 100
                                                    <li
                                                        key={"input-" + "table" + (tableIndex + 1) + "-name" + (rowIndex + 1) + "-" + type + "-per" + (monIndex + 1)} 
                                                        style={{color: typeIndex === 0 && row.budgetType === "Occupancy by Segmentation" && row.name.toLowerCase() === "ztotal" && Number(row[type + "-per" + (monIndex + 1)]) !== 100 ? "red" : ""}}>
                                                        <EllipsisWithTooltip placement="bottom">
                                                            {Utils.currencyFormatWithOutdoller(row[type + "-per" + (monIndex + 1)])}
                                                        </EllipsisWithTooltip>
                                                    </li>
                                                )
                                            }
                                        })
                                    }
                                </ul>
                            )}
                        </div>
                    );
                },
            }
            columns.push(col3);
        });
        let col4: any = {};
        col4 = {
            dataField: 'total-type1',
            text: "Avg/Total",
            headerAlign: 'right',
            align: 'right',
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div>
                        {!row.isSubHeader && (
                            <ul>
                                {
                                    tableDetails.subType1.map((type, index) => {
                                        return <li key={"row-total-" + type + "-" + rowIndex}><EllipsisWithTooltip placement="bottom">{Utils.currencyFormatWithOutdoller(row["total-" + type])}</EllipsisWithTooltip></li>
                                    })
                                }
                            </ul>
                        )}
                    </div>
                );
            },
        }
        columns.push(col4);

        return columns;
    }

    onInputChange = (e, detObj) => {
        // detObj: {table: row.budgetType, tableNo: "table" + (tableIndex + 1), name: row.name, rowNo: rowIndex + 1, type: type, month: monIndex + 1}
        let tablesData = Object.assign([], JSON.parse(JSON.stringify(this.state.tablesData)));
        let inputId = "";
        let cursorIndex = -1;
        inputId = "input-" + detObj.tableNo + "-name" + detObj.rowNo + "-" + detObj.type + "-per" + detObj.month; //input-table1-name1-type1-per1
        cursorIndex = e.target.selectionStart;
        let index = tablesData.findIndex((x) => x.budgetType === detObj.table && x.name === detObj.name && !x.isSubHeader);
        if (detObj.table.toLowerCase() === "adr by segmentation") {
            tablesData[index][detObj.type + "-per" + detObj.month] = Utils.removeInvaildCharFromAmount(e.target.value);  //type1-per1
        } else {
            tablesData[index][detObj.type + "-per" + detObj.month] = Utils.removeInvaildCharFromAmount(e.target.value.replace(/-/g, ""));  //type1-per1  // occ% is +ve
        }
        this.setState({ tablesData, isModified: true, }, () => {
            $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
        });
    }

    onInputBlur = (e, detObj) => {
        let tablesData = Object.assign([], JSON.parse(JSON.stringify(this.state.tablesData)));
        let index = tablesData.findIndex((x) => x.budgetType === detObj.table && x.name === detObj.name && !x.isSubHeader);
        let isInvalidNo = isNaN(e.target.value);
        tablesData[index][detObj.type + "-per" + detObj.month] = isInvalidNo ? "0.00" : Number(tablesData[index][detObj.type + "-per" + detObj.month]);  //type1-per1
        this.setState({ tablesData }, () => {
            this.calculateUpdatedData(detObj.month);
        });
    }

    calculateUpdatedData = (month) => {
        // debugger;
        let tablesData = Object.assign([], JSON.parse(JSON.stringify(this.state.tablesData)));
        tablesData = this.convertArrData("number", tablesData);
        let distinctTablesDetails = Object.assign([], JSON.parse(JSON.stringify(this.state.distinctTablesDetails)));
        let totalAvRmsMonthly = this.state.roomCountArr.filter((data) => data.month === month)[0].rmCount;
        let totalAvRmsYearly = this.state.roomCountArr.reduce((acc, item) => Number(acc) + Number(item.rmCount || 0), 0);
        let totalRmsSoldMonthly = 0;
        let totalRmsSoldYearly = 0;
        let totalRmRevenueYearly = 0;

        for (let i = 0; i < distinctTablesDetails.length; i++) {
            for (let j = 0; j < distinctTablesDetails[i].distinctNames.length; j++) {
                if (i === 0) {
                    let index = 0;
                    index = tablesData.findIndex((x) => x.budgetType === distinctTablesDetails[i].budgetType && x.name === distinctTablesDetails[i].distinctNames[j] && !x.isSubHeader);

                    tablesData[index]["type4-per" + month] = totalAvRmsMonthly * tablesData[index]["type1-per" + month] / 100;
                    tablesData[index]["total-type4"] = this.sumOfPeriods(tablesData[index], "type4");
                    tablesData[index]["total-type1"] = isNaN(tablesData[index]["total-type4"] / totalAvRmsYearly) ? "0.00" : tablesData[index]["total-type4"] / totalAvRmsYearly * 100;
                    totalRmsSoldMonthly = tablesData[index]["type4-per" + month];
                    totalRmsSoldYearly = tablesData[index]["total-type4"];
                } else if (i === 1) {
                    let index = 0;
                    index = tablesData.findIndex((x) => x.budgetType === distinctTablesDetails[i].budgetType && x.name === distinctTablesDetails[i].distinctNames[j] && !x.isSubHeader);

                    if (distinctTablesDetails[i].distinctNames[j].toLowerCase() !== "ztotal") {
                        tablesData[index]["type4-per" + month] = totalRmsSoldMonthly * tablesData[index]["type1-per" + month] / 100;
                        tablesData[index]["total-type4"] = this.sumOfPeriods(tablesData[index], "type4");
                        tablesData[index]["total-type1"] = isNaN(tablesData[index]["total-type4"] / totalRmsSoldYearly) ? "0.00" : tablesData[index]["total-type4"] / totalRmsSoldYearly * 100;
                    } else {
                        tablesData[index]["type1-per" + month] = this.sumOfSegments(tablesData, distinctTablesDetails[i].budgetType, "type1-per" + month);
                        tablesData[index]["type4-per" + month] = this.sumOfSegments(tablesData, distinctTablesDetails[i].budgetType, "type4-per" + month);
                        tablesData[index]["total-type1"] = this.sumOfPeriods(tablesData[index], "type1") / 12;
                        tablesData[index]["total-type4"] = this.sumOfPeriods(tablesData[index], "type4");
                    }
                } else if (i === 2) {
                    let index = 0;
                    let index1 = 0;
                    index1 = tablesData.findIndex((x) => x.budgetType === distinctTablesDetails[1].budgetType && x.name === distinctTablesDetails[1].distinctNames[j] && !x.isSubHeader);
                    let rmSoldForASgmntMonthly = tablesData[index1]["type4-per" + month]; //Monthly Segment Room Sold
                    let rmSoldForASgmntYearly = tablesData[index1]["total-type4"]; //Yearly Segment Room Sold
                    index = tablesData.findIndex((x) => x.budgetType === distinctTablesDetails[i].budgetType && x.name === distinctTablesDetails[i].distinctNames[j] && !x.isSubHeader);

                    if (distinctTablesDetails[i].distinctNames[j].toLowerCase() !== "ztotal") {
                        tablesData[index]["type4-per" + month] = rmSoldForASgmntMonthly * tablesData[index]["type1-per" + month]; //Monthly Segment Room Revenue
                        tablesData[index]["total-type4"] = this.sumOfPeriods(tablesData[index], "type4");  // Yearly Segment Room Revenue
                        tablesData[index]["total-type1"] = isNaN(tablesData[index]["total-type4"] / rmSoldForASgmntYearly) ? "0.00" : tablesData[index]["total-type4"] / rmSoldForASgmntYearly;
                    } else {
                        tablesData[index]["type4-per" + month] = this.sumOfSegments(tablesData, distinctTablesDetails[i].budgetType, "type4-per" + month);
                        tablesData[index]["type1-per" + month] = isNaN(tablesData[index]["type4-per" + month] / totalRmsSoldMonthly) ? "0.00" : tablesData[index]["type4-per" + month] / totalRmsSoldMonthly;
                        tablesData[index]["total-type4"] = this.sumOfPeriods(tablesData[index], "type4");
                        totalRmRevenueYearly = tablesData[index]["total-type4"]
                        tablesData[index]["total-type1"] = isNaN(totalRmRevenueYearly / totalRmsSoldYearly) ? "0.00" : totalRmRevenueYearly / totalRmsSoldYearly;
                    }
                } else if (i === 3) {
                    let index = 0;
                    index = tablesData.findIndex((x) => x.budgetType === distinctTablesDetails[i].budgetType && x.name === distinctTablesDetails[i].distinctNames[j] && !x.isSubHeader);
                    let totalRmRevenueMonthly = tablesData.filter((x) => x.budgetType === distinctTablesDetails[2].budgetType && x.name.toLowerCase() === "ztotal" && !x.isSubHeader)[0]["type4-per" + month]  // Room Revenue is in Table 3

                    if (distinctTablesDetails[i].distinctNames[j].toLowerCase() === "adr") {
                        tablesData[index]["type1-per" + month] = isNaN(totalRmRevenueMonthly / totalRmsSoldMonthly) ? "0.00" : totalRmRevenueMonthly / totalRmsSoldMonthly;
                        tablesData[index]["total-type1"] = isNaN(totalRmRevenueYearly / totalRmsSoldYearly) ? "0.00" : totalRmRevenueYearly / totalRmsSoldYearly;
                    } else if (distinctTablesDetails[i].distinctNames[j].toLowerCase() === "revpar") {
                        tablesData[index]["type1-per" + month] = isNaN(totalRmRevenueMonthly / totalAvRmsMonthly) ? "0.00" : totalRmRevenueMonthly / totalAvRmsMonthly;
                        tablesData[index]["total-type1"] = isNaN(totalRmRevenueYearly / totalAvRmsYearly) ? "0.00" : totalRmRevenueYearly / totalAvRmsYearly;
                    } else if (distinctTablesDetails[i].distinctNames[j].toLowerCase() === "total room revenue") {
                        tablesData[index]["type1-per" + month] = totalRmRevenueMonthly;
                        tablesData[index]["total-type1"] = this.sumOfPeriods(tablesData[index], "type1");
                    }
                }

            }
        }
        tablesData = this.convertArrData("string", tablesData);
        this.setState({ tablesData });
    }

    convertArrData = (type, arr) => {
        let data = Object.assign([], JSON.parse(JSON.stringify(arr)));
        const format = (val) => {
            const num = parseFloat(val);
            if (isNaN(num)) return type === 'string' ? '0.00' : 0;
            return type === 'string' ? num.toFixed(2) : +num.toFixed(2);
        };

        return data.map((item) => {
            const newItem = { ...item };

            for (let t = 1; t <= 4; t++) {
                for (let m = 1; m <= 12; m++) {
                    const key = `type${t}-per${m}`;
                    if (key in newItem) {
                        newItem[key] = format(newItem[key]);
                    }
                }

                const totalKey = `total-type${t}`;
                if (totalKey in newItem) {
                    newItem[totalKey] = format(newItem[totalKey]);
                }
            }

            return newItem;
        });
    }

    sumOfPeriods = (obj, type) => {
        let sum = 0;

        Object.keys(obj).forEach(key => {
            const parts = key.split('-');

            if (parts.length === 2 && parts[0] === type) {
                sum += Number(obj[key]);
            }
        });

        return sum;
    }

    sumOfSegments = (tablesData, budgetType, field) => {
        let sum = 0;
        let data = tablesData.filter((x) => x.budgetType === budgetType && !x.isSubHeader && x.name.toLowerCase() !== "ztotal");
        sum = data.reduce((acc, item) => {
            return Number(acc) + Number(item[field] || 0)
        }, 0);

        return sum;
    }

    handleDiscard = () => {
        let tablesData = Object.assign([], JSON.parse(JSON.stringify(this.state.tablesDataCopy)));
        this.setState({ tablesData, isModified: false, });
    }

    validateForm = () => {
        let isValid = true;
        let tablesData = Object.assign([], JSON.parse(JSON.stringify(this.state.tablesData)));
        let occTotalRow = tablesData.filter((data) => data.budgetType.toLowerCase() === "occupancy by segmentation" && data.name.toLowerCase() === "ztotal");

        for (let i = 1; i <= 12; i++) {
            if (Number(occTotalRow[0]?.["type1-per" + i]) !== 100) {
                isValid = false;
                break;
            }
        }

        if (isValid) {
            Utils.toastSuccess("Form is Valid.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OprBud_ReoomRevenue_FormValid",
            });
        } else {
            Utils.toastError("Total percentage can not be less or greater than 100, it should be equal to 100%.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OprBud_ReoomRevenue_FormInvalid",
            });
        }
    }

    render() {
        const { openEventKey } = this.state;
        const rowClasses = (row, rowIndex) => {
            let classes = "";
      
            if (row.isSubHeader) {
              classes = "heading";
            } else if (row.name.toLowerCase() === "ztotal") {
              classes = "ttlRow";
            } else if (row.name.toLowerCase() === "total room revenue") {
              classes = "ttlRoomRevenue";
            }
      
            return classes;
          };
        return (
            <div className='room-revenue common-leyout'>
                <div className='header filter-section'></div>
                {this.state.isDataLoaded &&
                    <div className={`body-sec scroll-area ${this.state.isModified ? "footer-enable" : ""}`}>
                        <Accordion activeKey={openEventKey}>
                            {this.state.distinctTablesDetails.map((table, index) => {
                                if (index === 2) {
                                    return;
                                }
                                return (
                                    <Card>
                                        <Card.Header className='d-flex align-items-center'>
                                            <CustomToggle
                                                eventKey={index.toString()}
                                                onToggle={this.handleToggle}
                                                isOpen={openEventKey.includes(index.toString())}
                                            >
                                                Click me!
                                            </CustomToggle>
                                            <div className='heading'>{`${index === 3 ? index : index + 1}. ${index === 1 ? "Segmentation Mix" : table.budgetType}`}</div>
                                            <div className='status green ml-auto'>Complete</div>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey={index.toString()} in={openEventKey.includes(index.toString())}>
                                            <Card.Body>
                                                <div className='budget-list'>
                                                    {
                                                        this.state.isDataLoaded &&
                                                        <BootstrapTable
                                                            keyField='id'
                                                            data={this.state.tablesData.filter(
                                                                (data) => {
                                                                    if (index === 1) {
                                                                        return data.budgetType === table.budgetType || data.budgetType === this.state.distinctTablesDetails[index + 1].budgetType
                                                                    } else {
                                                                        return data.budgetType === table.budgetType
                                                                    }
                                                                }
                                                            )}
                                                            columns={this.getColumns(table.firstHeader, table.budgetType)}
                                                            rowClasses={rowClasses}
                                                        />
                                                    }
                                                </div>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                )
                            })}
                        </Accordion>
                    </div>
                }
                {this.state.isModified &&
                    <div className='footer-section d-flex align-items-center'>
                        <div className='msg'>You have unsaved changes</div>
                        <div className='ml-auto action'>
                            <Button variant="primary" type="button" className="space btn btn-primary btn-discard" onClick={() => this.handleDiscard()}>Discard</Button>
                            <Button variant="primary" type="button" className="btn btn-primary" onClick={() => this.validateForm()}>Save Changes</Button>
                        </div>
                    </div>
                }
                {this.state.showLoader && (
                    <div className="loader-spinner d-flex justify-content-center align-items-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                )}
            </div>
        );
    }
}